import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import "./utils/globalLibraries";
import GlobalComponents from "./utils/globalComponents";
Vue.use(GlobalComponents);

//fix variables
if(window.location.hostname === process.env.VUE_APP_LOCALHOST)
{
  Vue.prototype.$BaseUrl = process.env.VUE_APP_Base_Url_LOCAL;
}
else
{
  Vue.prototype.$BaseUrl = process.env.VUE_APP_Base_Url;
}
Vue.prototype.$lastError = 0;
Vue.prototype.$lastErrorStatus = 0;

Vue.config.productionTip = false;
Date.prototype.addMin = function(m) {
  this.setTime(this.getTime() + (m*60*1000));
  return this;
}
Date.prototype.addHours = function(m) {
  this.setTime(this.getTime() + (m*60*60*1000));
  return this;
}

var moment = require('jalali-moment');
Vue.mixin({
  methods: {
    GetMiladi: (input, type="date", locale="fa") => {
      if (!input)
        return '';
      var format = "YYYY/MM/DD";
      if(type === 'datetime')
      {
        format = "YYYY/MM/DD hh:mm";
      }
       // console.log(input, moment.from(input, 'fa', format).format())
      //let locale = 'fa'; // store.state.appConfig;
      if (locale === 'fa')
       {
          return moment.from(input, 'fa', format).format();
       }
      else
       {
         return input;
         //return moment(String(input)).format('MM/DD/YYYY hh:mm');
      } 
    },
    AddToDate:(input,type, count) =>{
      if(type == 'month'){
        return moment(input).add(count, 'M').format('YYYY/MM/DD');
      }
      else if(type == 'year'){
        return moment(input).add(count, 'years').format('YYYY/MM/DD');
      }
      else if(type == 'day'){
        return moment(input).add(count, 'years').format('YYYY/MM/DD');
      }
    },
    CalDiff:(input1 , input2 , type="days")=>{
    var a=moment(input1)
    var b= moment(input2)
    //alert(type)
    console.log(a)
    console.log(b)
    console.log(a.diff(b, type))
    return a.diff(b, type)
    },
    ShowDate: (input, type, custom="") => {
      try {
        let locale = 'fa'; // store.state.appConfig;
        var m = moment(input);
        if (locale === 'fa')
          m = m.locale('fa');
        var format = "";
        switch (type) {
          case "strdate":
            format = 'dddd Do MMMM YYYY';
            break;
          case "strdatetime":
            format = 'dddd Do MMMM YYYY - HH:mm';
            break;
          case "date":
            format = 'YYYY/MM/DD';
            break;
          case "time":
            format = 'HH:mm';
            break;
          case 'datetime':
            format = 'YYYY/MM/DD HH:mm';
            break;
          case 'custom':
            format = custom;
            break;
          case 'now':
            return m.from(new Date());
            break;
        }
       // console.log(input, m.format(format))
        return m.format(format);

      } catch (error) {
        return '';
      }
    },
  }
})

new Vue({
  router,
  store,
  vuetify,

  render: function (h) {
    return h(App)
  }
}).$mount('#app')
